// import menuImage from '../assets/image/menu-image.webp'

export const menuItems = [
  {
    name: "",
    label: "Home"
  },
  {
    name: "features",
    label: "Features"
  },
  {
    name: "pricing",
    label: "Pricing"
  },
  {
    name: "contact-us",
    label: "Contact Us"
  }
];
export default menuItems;